(function () {
  "use strict";

  const PRODUCTS = [
    "Gym T-shirts",
    "Tanktops",
    "Shorts",
    "Trackpants",
    "Flared Pants",
    "Jackets",
    "Tracksuits",
    "Tumblers",
    "Paddles",
    "Pickleballs",
    "Co-ord Sets",
    "Posture Correctors",
  ];

  const FORM_SELECTOR = "shopify-forms-embed";

  const FIELD_SELECTOR = 'textarea[name="custom#products_quantities"]';

  function injectStyles(shadowRoot) {
    if (!shadowRoot) {
      return;
    }

    if (shadowRoot.querySelector("#product-quantity-shadow-styles")) {
      return;
    }

    const style = document.createElement("style");

    style.id = "product-quantity-shadow-styles";

    style.textContent = `

            .product-quantity-selector {
                display: block !important;
                width: 100% !important;
                margin: 0 0 0px !important;
                padding: 0 !important;
                box-sizing: border-box !important;
                color: #202020 !important;
                background: transparent !important;
                text-align: left !important;
            }


            .product-quantity-selector__label {
                display: none !important;
                width: 100% !important;
                margin: 0 0 8px !important;
                padding: 0 !important;
                color: #202020 !important;
                font-size: 14px !important;
                line-height: 1.4 !important;
                font-weight: 500 !important;
                text-align: left !important;
                background: transparent !important;
            }


            .product-quantity-selector__select {
                display: block !important;
                width: 100% !important;
                height: 48px !important;
                margin: 0 !important;
                padding: 0 42px 0 15px !important;
                border: 1px solid rgba(32, 32, 32, 0.2) !important;
                border-radius: 5px !important;
                background-color: #ffffff !important;
                color: #202020 !important;
                font-size: 14px !important;
                line-height: 48px !important;
                font-family: inherit !important;
                text-align: left !important;
                cursor: pointer !important;
                box-sizing: border-box !important;
                opacity: 1 !important;
                visibility: visible !important;
                appearance: auto !important;
                -webkit-appearance: auto !important;
            }

            .product-quantity-selector__select option {
                color: #202020 !important;
                background: #ffffff !important;
                font-size: 14px !important;
            }

            .product-quantity-selector__select:focus {
                outline: none !important;
                border-color: #1878b9 !important;
                color: #202020 !important;
            }

            .product-quantity-selector__select--error {
                border: 2px solid #e02229 !important;
            }


            .product-quantity-selector__select--error:focus {
                border-color: #e02229 !important;
            }

            .product-quantity-selector__selected {
                display: none;
                flex-direction: column !important;
                width: 100% !important;
                margin: 10px 0 0 !important;
                padding: 0 !important;
                gap: 8px !important;
                box-sizing: border-box !important;
            }

            .product-quantity-selector__row {
                display: flex !important;
                align-items: center !important;
                width: 100% !important;               
                 min-height: 48px !important;
                margin: 0 !important;
                padding: 8px 10px !important;
                border: 1px solid rgba(32, 32, 32, 0.12) !important;
                border-radius: 5px !important;
                background: #ffffff !important;
                color: #202020 !important;
                box-sizing: border-box !important;
            }

            .product-quantity-selector__product {
                flex: 1 1 auto !important;
                min-width: 0 !important;
                margin: 0 !important;
                padding: 0 10px 0 0 !important;
                color: #202020 !important;
                font-size: 14px !important;
                line-height: 1.3 !important;
                font-weight: 400 !important;
                text-align: left !important;
                background: transparent !important;
            }

            .product-quantity-selector__quantity {
                display: block !important;
                width: 65px !important;
                height: 36px !important;
                margin: 0 !important;
                padding: 0 8px !important;
                border: 1px solid rgba(32, 32, 32, 0.2) !important;
                border-radius: 4px !important;
                background: #ffffff !important;
                color: #202020 !important;
                font-size: 14px !important;
                font-family: inherit !important;
                text-align: center !important;
                box-sizing: border-box !important;
            }

            .product-quantity-selector__quantity:focus {
                outline: none !important;
                border-color: #1878b9 !important;
            }

            .product-quantity-selector__remove {
                display: block !important;
                flex: 0 0 32px !important;
                width: 32px !important;
                height: 32px !important;
                margin: 0 0 0 8px !important;
                padding: 0 !important;
                border: 0 !important;
                background: transparent !important;
                color: #666666 !important;
                font-size: 22px !important;            
                    line-height: 32px !important;
                text-align: center !important;
                cursor: pointer !important;
            }

            .product-quantity-selector__remove:hover {
                color: #e02229 !important;
            }

            @media screen and (max-width: 490px) {
                .product-quantity-selector__row {
                    padding: 8px !important;
                }
                .product-quantity-selector__product {
                    font-size: 13px !important;
                }

                .product-quantity-selector__quantity {
                    width: 58px !important;
                }
            }

            ._formFieldContainer_1mxsl_5:has(textarea)::before{
                display: none !important;
            }

        `;
    shadowRoot.appendChild(style);
  }

  function getEmbed() {
    return document.querySelector(FORM_SELECTOR);
  }

  function getForm(embed) {
    if (!embed || !embed.shadowRoot) {
      return null;
    }

    return embed.shadowRoot.querySelector("form");
  }
  function updateShopifyField(textarea, products) {
    const value = Array.from(products.entries())
      .map(function ([product, quantity]) {
        return `${product}: ${quantity}`;
      })
      .join(" || ");

    const setter = Object.getOwnPropertyDescriptor(
      HTMLTextAreaElement.prototype,
      "value",
    ).set;

    setter.call(textarea, value);

    textarea.dispatchEvent(
      new Event("input", {
        bubbles: true,
        composed: true,
      }),
    );

    textarea.dispatchEvent(
      new Event("change", {
        bubbles: true,
        composed: true,
      }),
    );

    console.log("[Product Quantity] Value:", value);
  }

  function initialize() {
    const embed = getEmbed();

    if (!embed || !embed.shadowRoot) {
      return false;
    }

    const shadowRoot = embed.shadowRoot;
    injectStyles(shadowRoot);
    const form = getForm(embed);
    if (!form) {
      return false;
    }
    const textarea = form.querySelector(FIELD_SELECTOR);
    if (!textarea) {
      console.log("[Product Quantity] Products field not found.");
      return false;
    }

    if (textarea.dataset.productQuantityInitialized === "true") {
      return true;
    }

    textarea.dataset.productQuantityInitialized = "true";

    console.log("[Product Quantity] Initializing...");

    const selectedProducts = new Map();

    const fieldContainer = textarea.closest('div[class*="formFieldContainer"]');

    if (!fieldContainer) {
      console.log("[Product Quantity] Field container not found.");
      return false;
    }

    textarea.style.setProperty("display", "none", "important");

    const labels = fieldContainer.querySelectorAll("label");

    labels.forEach(function (label) {
      if (label.textContent.trim().toLowerCase() === "products & quantities") {
        label.style.setProperty("display", "none", "important");
      }
    });
    const wrapper = document.createElement("div");

    wrapper.className = "product-quantity-selector";
    const customLabel = document.createElement("label");

    customLabel.className = "product-quantity-selector__label";

    customLabel.textContent = "Products & Quantities";
    const select = document.createElement("select");

    select.className = "product-quantity-selector__select";

    const SELECT_ERROR_CLASS = "product-quantity-selector__select--error";

    const defaultOption = document.createElement("option");

    defaultOption.value = "";
    defaultOption.textContent = "Select a product";

    defaultOption.selected = true;

    select.appendChild(defaultOption);

    PRODUCTS.forEach(function (product) {
      const option = document.createElement("option");

      option.value = product;

      option.textContent = product;

      select.appendChild(option);
    });
    const selectedContainer = document.createElement("div");

    selectedContainer.className = "product-quantity-selector__selected";

    function updateDefaultOptionLabel() {
      defaultOption.textContent =
        selectedProducts.size > 0 ? "Add More Product" : "Select a product";
    }

    function setSelectError(hasError) {
      select.classList.toggle(SELECT_ERROR_CLASS, Boolean(hasError));
    }

    function clearSelectError() {
      setSelectError(false);
    }

    function hasErrorClass(element) {
      if (!element) {
        return false;
      }

      const className =
        typeof element.className === "string"
          ? element.className
          : (element.className && element.className.baseVal) || "";

      return /error|invalid/i.test(className);
    }

    function fieldContainerHasRequiredMessage() {
      return fieldContainer.textContent.toLowerCase().includes("required");
    }

    function detectFieldError() {
      if (textarea.getAttribute("aria-invalid") === "true") {
        return true;
      }

      if (hasErrorClass(textarea)) {
        return true;
      }

      if (hasErrorClass(fieldContainer)) {
        return true;
      }

      if (fieldContainerHasRequiredMessage()) {
        return true;
      }

      return false;
    }

    function syncErrorStateFromDom() {
      if (selectedProducts.size > 0) {
        clearSelectError();

        return;
      }

      setSelectError(detectFieldError());
    }

    let syncScheduled = false;

    function scheduleSync() {
      if (syncScheduled) {
        return;
      }

      syncScheduled = true;

      requestAnimationFrame(function () {
        syncScheduled = false;

        syncErrorStateFromDom();
      });
    }

    const fieldErrorObserver = new MutationObserver(scheduleSync);

    fieldErrorObserver.observe(fieldContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class", "aria-invalid"],
    });
    const submitControl = form.querySelector(
      'button[type="submit"], input[type="submit"]',
    );

    if (submitControl) {
      submitControl.addEventListener("click", function () {
        [0, 50, 150, 400, 800].forEach(function (delay) {
          setTimeout(syncErrorStateFromDom, delay);
        });
      });
    }

    function renderProducts() {
      selectedContainer.innerHTML = "";

      updateDefaultOptionLabel();

      clearSelectError();

      if (selectedProducts.size === 0) {
        selectedContainer.style.display = "none";

        updateShopifyField(textarea, selectedProducts);

        return;
      }

      selectedContainer.style.display = "flex";

      selectedProducts.forEach(function (quantity, product) {
        const row = document.createElement("div");

        row.className = "product-quantity-selector__row";

        const productName = document.createElement("span");

        productName.className = "product-quantity-selector__product";

        productName.textContent = product;

        const quantityInput = document.createElement("input");

        quantityInput.type = "number";

        quantityInput.min = "1";

        quantityInput.step = "1";

        quantityInput.value = quantity;

        quantityInput.className = "product-quantity-selector__quantity";

        quantityInput.addEventListener("input", function () {
          let newQuantity = parseInt(quantityInput.value, 10);

          if (isNaN(newQuantity) || newQuantity < 1) {
            newQuantity = 1;

            quantityInput.value = 1;
          }

          selectedProducts.set(product, newQuantity);

          updateShopifyField(textarea, selectedProducts);
        });

        const removeButton = document.createElement("button");

        removeButton.type = "button";

        removeButton.className = "product-quantity-selector__remove";

        removeButton.textContent = "×";

        removeButton.setAttribute("aria-label", `Remove ${product}`);

        removeButton.addEventListener("click", function () {
          selectedProducts.delete(product);

          renderProducts();
        });

        row.appendChild(productName);

        row.appendChild(quantityInput);

        row.appendChild(removeButton);

        selectedContainer.appendChild(row);
      });

      updateShopifyField(textarea, selectedProducts);
    }

    select.addEventListener("change", function () {
      const product = select.value;

      if (!product) {
        return;
      }

      if (!selectedProducts.has(product)) {
        selectedProducts.set(product, 1);

        renderProducts();
      }
      select.value = "";
    });

    wrapper.appendChild(customLabel);

    wrapper.appendChild(select);

    wrapper.appendChild(selectedContainer);
    fieldContainer.insertBefore(wrapper, textarea);

    renderProducts();

    console.log("[Product Quantity] Initialized successfully.");

    return true;
  }

  function start() {
    console.log("[Product Quantity] Script loaded.");

    if (initialize()) {
      return;
    }

    let attempts = 0;

    const timer = setInterval(function () {
      attempts++;
      if (initialize()) {
        clearInterval(timer);
        console.log("[Product Quantity] Initialized.");
        return;
      }
      if (attempts >= 40) {
        clearInterval(timer);
        console.log("[Product Quantity] Initialization stopped.");
      }
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true,
    });
  } else {
    start();
  }
})();
